/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalQuestionsTimeToAnswerDataSchema = z.object({
	questionId: z.string(),
	position: z.number(),
	label: z.string(),
	type: z.string(),
	avgTimeToAnswerMs: z.number().nullable(),
	answerCount: z.number(),
})

export type AdditionalQuestionsTimeToAnswerDataSchema = z.infer<typeof additionalQuestionsTimeToAnswerDataSchema>
